<template>
  <div class='unknown-page 404-page'>
    <div class='unknown-page__section'>

      <div class='bg-white'>
        <div class='unknown-page__heading lightblue-bg'>
          <div class='container'>
            <div class='d-flex flex-column flex-md-row'>
              <div class='col-md-6 right-side text-center text-md-right'>
                <img src='@/assets/images/404-error.svg' alt='404'>
              </div>
              <div class='col-md-7 left-side'>
                <h1>We’re really sorry
                  <span>Looks like we can’t find the page you’re looking for!</span>
                </h1>
                <p class="fw-extrabold mb-0 helpful-links-text">
                  Below are some helpful links that you may want to check out instead.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class='unknown-page__inner'>
        <nav class='unknown-page__navigation'>
          <ul class='unknown-page__navigation-list'>
            <li class='def-btn def-btn--golden' @click.prevent='goToPage("home")'>
              Home
            </li>
            <li v-for='(menuItem, menuItemIndex) in menu' :key='menuItemIndex' class='def-btn def-btn--golden'
              @click.prevent='goToPage(menuItem.routerLinkName)' v-html='menuItem.title'></li>
          </ul>
        </nav>
      </div>
    </div>
    <InfoBlockSticky />
    <InfoBlock class='trigger' />
    <Footer />
  </div>
</template>

<script>
import { menu } from '../globalVariables'
import InfoBlock from '../components/sections/InfoBlock'
import InfoBlockSticky from '../components/sections/InfoBlockSticky'
import Footer from '../components/sections/Footer'

export default {
  name: 'UnknownPage',
  metaInfo: {
    title: '404',
    meta: [
      {
        hid: 'robots',
        name: 'robots',
        content: 'noindex'
      },
      {
        hid: 'robots',
        name: 'robots',
        content: 'nofollow'
      }
    ]
  },

  components: {
    InfoBlockSticky,
    InfoBlock,
    Footer
  },
  data () {
    return {
      menu
    }
  },
  methods: {
    goToPage (routerLinkName) {
      this.$router.push({
        name: routerLinkName
      })
    }
  }
}
</script>
